import { Action } from '@ngrx/store';
import {FirmWareLog, FirmWareLogParams} from '../firm-ware.model';

export enum FirmWareLogActionTypes {
  LoadFirmWareLogs = '[FirmWareLog] Load FirmWareLogs',
  GetFirmWareLogs = '[FirmWareLog] Get FirmWareLogs',
  GetFirmWareLogsFail = '[FirmWareLog] Get FirmWareLogs Fail',
  LoadFirmwareMgtLogs = '[FirmWareLog] Load FirmwareMgtLogs',
  GetFirmwareMgtLogs = '[FirmWareLog] Get FirmwareMgtLogs',
  GetFirmwareMgtLogsFail = '[FirmWareLog] Get FirmwareMgtLogs Fail'
}

export class LoadFirmWareLogs implements Action {
  readonly type = FirmWareLogActionTypes.LoadFirmWareLogs;
  constructor(public payload: FirmWareLog[]) {}
}

export class GetFirmWareLogs implements Action {
  readonly type = FirmWareLogActionTypes.GetFirmWareLogs;
  constructor(public payload: FirmWareLogParams) {}
}

export class GetFirmWareLogsFail implements Action {
  readonly type = FirmWareLogActionTypes.GetFirmWareLogsFail;
}

export class LoadFirmwareMgtLogs implements Action {
  readonly type = FirmWareLogActionTypes.LoadFirmwareMgtLogs;
  constructor(public payload: FirmWareLog[]) {}
}

export class GetFirmwareMgtLogs implements Action {
  readonly type = FirmWareLogActionTypes.GetFirmwareMgtLogs;
  constructor(public payload: FirmWareLogParams) {}
}

export class GetFirmwareMgtLogsFail implements Action {
  readonly type = FirmWareLogActionTypes.GetFirmwareMgtLogsFail;
}

export type FirmWareLogActions = LoadFirmWareLogs
  | GetFirmWareLogs
  | GetFirmWareLogsFail
  | LoadFirmwareMgtLogs
  | GetFirmwareMgtLogs
  | GetFirmwareMgtLogsFail;
